<template>
    <div class="home-view">
        <Topbar />
        <br>
        <div class="container-img mt-2 small pb-3">
            <div class="col-10 col-md-4 mt-5" style="gap: 2em;">
                <div v-for="(item) in menus" :key="item.idmenusthorpecoletor">
                    <div v-if="item.idmenupai == categoriaId">
                        <div class="router-link" @click="() => selecionarModulo(item)">
                            <div :class="['card link mb-2']" :style="'background-color: ' +item.color">
                                <div class="card-body text-center text-white p-1">
                                    <em :class="[item.icone, 'fa-2x']"></em>
                                </div>
                                <div class="card-footer text-center p-0 text-white">
                                    {{ item.nome }}
                                </div>
                            </div>
                          </div>
                    </div>
                </div>
            </div>
        </div>
        <router-link to="/">
            <em class="fa fa-arrow-circle-left fa-3x text-info"></em>
        </router-link>
        <br>
        <br>
        <br>
        <LogoutModal />
        <FooterBar />
    </div>
</template>
  
  
  <script>
  // @ is an alias to /src
  import Topbar from '@/components/Topbar.vue'
  import FooterBar from '@/components/FooterBar.vue'
  import LogoutModal from '@/components/LogoutModal.vue'
  import ViewMixin from './ViewMixin'
  import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
  import api, { setModuloAtual, getUsername, getPerfil } from '../services/api'

  export default {
    name: 'Categoria',
    mixins: [
      ViewMixin
    ],
    components: {
      Topbar,
      LogoutModal,
      FooterBar
    },
  
    data: () => {
      return {
        menus : [],
        categoriaId: null,
      };
    },
  
    async mounted() {
      try {
        await this.validarToken();
        await this.getMenus();
      } catch (e) {
        if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ServerErrorException) {
          alert(e.message);
        } else {
          alert(DEFAULT_ERROR_MESSAGE);
        }      
      }
    },
  
    methods: {
      getUsername,
      getPerfil,

      async validarToken() {
        this.carregando = true;
  
        await api.get("/validar-token");
  
        this.carregando = false;
      },

      selecionarModulo(modulo) {
        setModuloAtual(JSON.stringify(modulo))
        this.$router.push(modulo.path)
      },

      async getMenus() {
          this.categoriaId = this.$route.params.idmenu;
          this.carregando = true;

          if (getPerfil() == 'null') {
              this.perfilColetor = "SEM PERFIL";
          } else if (!sessionStorage.getItem("menus")) {
              
              let response = await api.post("/menus", {
                  idPerfil: getPerfil()
              });

              this.menus = response.data;
              sessionStorage.setItem("menus", JSON.stringify(response.data));
          } else {
              this.menus = JSON.parse(sessionStorage.getItem("menus"));
          }

          this.carregando = false;
      },
    }
  }
  </script>
  
  <style scoped lang="scss">    
  
    .home-view {
      height: 100%;
    }
  
    .container-img {
      height: auto;
      display: flex;
      justify-content: center;
      align-self: center;
    }
  
    img {    
      filter: drop-shadow(0px 0px 100px rgba(0, 0, 0, 0.2));
      max-width: 80%;
    }
  
    @media only screen and (min-width: 768px) {
      img {    
        max-width: 40%;
      }
    }

    .router-link {
      text-decoration: none; 
    }

    .link {
      transition: box-shadow .3s;
    }

    .link:hover {
      box-shadow: 0 0 50px rgba(0, 0, 0, 0.255); 
    }
  </style>
  